import { t } from 'i18next'

import { EstadoCivilEnum } from '@/types/cliente'
import { assinaturaContratoEnum, ClienteRegimeCasamentoEnum } from '@/types/proposta'

export const UNIAO_ESTAVEL_OPTIONS = [
  {
    value: 'sim',
    label: t('proposta:cadastro_compradores.steps.estado_civil.uniao_estavel.sim'),
  },
  {
    value: 'nao',
    label: t('proposta:cadastro_compradores.steps.estado_civil.uniao_estavel.nao'),
  },
]

export const ESTADO_CIVIL_OPTIONS = [
  { value: EstadoCivilEnum.CivilCasado, label: t('proposta:cadastro_compradores.steps.estado_civil.opcoes.casado') },
  {
    value: EstadoCivilEnum.CivilDivorciado,
    label: t('proposta:cadastro_compradores.steps.estado_civil.opcoes.divorciado'),
  },
  {
    value: EstadoCivilEnum.CivilSeparadoJudicialmente,
    label: t('proposta:cadastro_compradores.steps.estado_civil.opcoes.separado'),
  },
  {
    value: EstadoCivilEnum.CivilSolteiro,
    label: t('proposta:cadastro_compradores.steps.estado_civil.opcoes.solteiro'),
  },
  { value: EstadoCivilEnum.CivilViuvo, label: t('proposta:cadastro_compradores.steps.estado_civil.opcoes.viuvo') },
]

export const REGIME_CASAMENTO_OPTIONS = [
  {
    value: ClienteRegimeCasamentoEnum.SeparacaoTotalBens,
    label: t('proposta:cadastro_compradores.steps.estado_civil.regime_casamento.separacao_total'),
  },
  {
    value: ClienteRegimeCasamentoEnum.ComunhaoParcialBens,
    label: t('proposta:cadastro_compradores.steps.estado_civil.regime_casamento.comunhao_parcial'),
  },
  {
    value: ClienteRegimeCasamentoEnum.ComunhaoUniversalBens,
    label: t('proposta:cadastro_compradores.steps.estado_civil.regime_casamento.comunhao_universal'),
  },
  {
    value: ClienteRegimeCasamentoEnum.SeparacaoLegal,
    label: t('proposta:cadastro_compradores.steps.estado_civil.regime_casamento.separacao_legal'),
  },
  {
    value: ClienteRegimeCasamentoEnum.SeparacaoObrigatoriaBens,
    label: t('proposta:cadastro_compradores.steps.estado_civil.regime_casamento.separacao_obrigatoria'),
  },
  {
    value: ClienteRegimeCasamentoEnum.SeparacaoConvencional,
    label: t('proposta:cadastro_compradores.steps.estado_civil.regime_casamento.separacao_convencional'),
  },
  {
    value: ClienteRegimeCasamentoEnum.ParticipacaoFinalNosAquestos,
    label: t('proposta:cadastro_compradores.steps.estado_civil.regime_casamento.participacao_aquestos'),
  },
]

export const TIPO_ASSINATURA_OPTIONS = {
  [assinaturaContratoEnum.Eletronica]: 'Eletrônica',
  [assinaturaContratoEnum.Impressa]: 'Impressa',
} as const
